import weight0 from './images/weight-0.png';
import weight1 from './images/weight-1.png';

export default {
  v: "5.3.4",
  fr: 29.9700012207031,
  ip: 0,
  op: 30.0000012219251,
  w: 200,
  h: 200,
  nm: "Comp 1",
  ddd: 0,
  assets: [
    { id: "image_0", w: 13, h: 13, u: "", p: weight0, e: 0 },
    { id: "image_1", w: 105, h: 112, u: "", p: weight1, e: 0 }
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 2,
      nm: "weightloss_needle.eps",
      cl: "eps",
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              n: ["0p667_1_0p333_0"],
              t: 0,
              s: [-147],
              e: [55]
            },
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              n: ["0p667_1_0p333_0"],
              t: 12,
              s: [55],
              e: [-28.667]
            },
            {
              i: { x: [0.667], y: [1] },
              o: { x: [0.333], y: [0] },
              n: ["0p667_1_0p333_0"],
              t: 23,
              s: [-28.667],
              e: [0]
            },
            { t: 28.0000011404634 }
          ],
          ix: 10
        },
        p: { a: 0, k: [97, 67.312, 0], ix: 2 },
        a: { a: 0, k: [3.5, 9.562, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 30.0000012219251,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 2,
      ty: 2,
      nm: "weightloss_scale.eps",
      cl: "eps",
      refId: "image_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [98, 98, 0], ix: 2 },
        a: { a: 0, k: [52.5, 56, 0], ix: 1 },
        s: { a: 0, k: [100, 100, 100], ix: 6 }
      },
      ao: 0,
      ip: 0,
      op: 30.0000012219251,
      st: 0,
      bm: 0
    }
  ],
  markers: []
};
